<template>
  <v-container flex grid-list-md>
    <template v-if="!smartLock">
      <smart-lock-message></smart-lock-message>
    </template>
    <template v-else>
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar
          color="#eee"
          class="elevation-0 secondary--text" >
          <v-toolbar-title>Relatório de Pedidos</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn round color="primary" @click="dialog=true"><v-icon class="mr-2">do_not_disturb_alt</v-icon> Limite de compra</v-btn>
        </v-toolbar>
      </v-flex>
    </v-layout>
    <v-layout row wrap justify-center>
      <v-flex xs12 sm5 md3>
        <v-flex xs12>
          Comprador
        </v-flex>
        <v-flex xs12>
          <v-select
            :items="[
              { text: 'Todos', value: 'todos' },
              { text: 'Empresa', value: 'empresa' },
              { text: 'Cliente', value: 'cliente' },
            ]"
            v-model="filtro_comprador"
            label="Tipo de comprador"
            item-text="text"
            item-value="value"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
            :items="items_comprador"
            :disabled="filtro_comprador === 'todos'"
            label="Filtro do comprador"
            item-text="text"
            item-value="value"
            v-model="item_selecionado"
            return-object
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-if="item_selecionado"
            :disabled="filtro_comprador === 'todos'"
            v-model="pesquisa_comprador"
            :label="item_selecionado.text"
          ></v-text-field>
        </v-flex>
      </v-flex>
      <v-divider vertical/>
      <v-flex xs12 sm6 md3>
        <v-flex xs12>
          Vendedor
        </v-flex>
        <v-flex xs12>
          <v-select
            :items="[
              {text: 'Todos', value: 'todos'},
              {text: 'Posto', value: 'posto'},
              {text: 'Empresa', value: 'empresa'},
              {text: 'Rede', value: 'rede'},
            ]"
            label="Tipo de vendedor"
            item-text="text"
            item-value="value"
            v-model="filtro_vendedor"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
            :items="dados_vendedor"
            label="Filtro do vendedor"
            item-text="text"
            item-value="value"
            :disabled="filtro_vendedor === 'todos'"
            v-model="dado_selecionado"
            return-object
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-if="dado_selecionado"
            v-model="pesquisa_vendedor"
            :label="dado_selecionado.text"
            :disabled="filtro_vendedor === 'todos'"
          ></v-text-field>
          <!--mask="###.###.###-##"-->
        </v-flex>
      </v-flex>
      <v-divider vertical/>
      <v-flex xs12 sm10 md4>
        <v-flex xs12>Dados do Pedido</v-flex>
        <v-layout row wrap justify-center>
          <v-flex xs12 sm12 md12 lg4>
            <v-select
              :items="[
                {text: 'SIM', value: true},
                {text: 'NÃO', value: false},
              ]"
              label="Finalizado"
              item-text="text"
              item-value="value"
              v-model="finalizado"
            ></v-select>
          </v-flex>
          <v-flex xs12 sm12 md12 lg4>
            <v-select
              :items="[
                { text: 'Todos', value: null },
                { text: 'No Estabelecimento', value: true},
                { text: 'No APP/Link de pagamento', value: false },
              ]"
              label="método de pagamento"
              item-text="text"
              item-value="value"
              v-model="pagamento_local"
            ></v-select>
          </v-flex>
          <v-flex xs6 sm6 md6 lg4 v-if="filtro && filtro.value === 'combustivel__nome__icontains'">
            <v-select
              :items="combustiveis"
              v-model="combustivel_selecionado"
              label="Selecione o combustível"
              item-text="nome"
              item-value="nome"
            ></v-select>
          </v-flex>
          <v-flex xs6 sm6 md6 lg4 v-else-if="filtro && filtro.value !== 'todas' && filtro.value !== 'valor'">
            <v-text-field
              v-model="filtro_pesquisa"
              :label="filtro.text"
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center>
          <v-flex xs3 sm2 md3>
            <v-select
              :items="itemsData"
              item-text="title"
              item-value="value"
              v-model="filtro_data"
            ></v-select>
          </v-flex>
          <v-flex xs8 sm4 md9>
            <v-menu
                ref="menuData"
                v-model="menuData"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-flex xs12>
                    <v-combobox
                      v-if="filtro_data === 'intervalo'"
                      v-model="intervalo_relatorio"
                      label="Dias"
                      multiple
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                    <v-combobox
                      v-else-if="filtro_data === 'dia'"
                      v-model="data_relatorio"
                      label="Dia"
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      @blur="date = parseDate(data_relatorio)"
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                    <v-combobox
                      v-else
                      v-model="mes_relatorio"
                      label="Mes"
                      persistent-hint
                      chips
                      small-chips
                      readonly
                      flat
                      @blur="month = parseDate(mes_relatorio)"
                      prepend-icon="event"
                      required
                      v-on="on"
                    ></v-combobox>
                  </v-flex>
                </template>
                <v-flex xs12>
                  <v-flex xs12>
                    <v-date-picker v-show="filtro_data === 'intervalo'" multiple v-model="dates" type="date" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                  </v-flex>
                  <v-flex xs12>
                    <v-date-picker v-show="filtro_data === 'dia'" v-model="date" type="date" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                  </v-flex>
                  <v-flex xs12>
                    <v-date-picker v-show="filtro_data === 'mes'" v-model="month" type="month" color="primary" no-title @input="dataSelecionada"></v-date-picker>
                  </v-flex>
                </v-flex>
              </v-menu>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs2 md1 align-self-center class="text-xs-right">
        <v-btn icon @click="carregarPedidos()">
          <v-icon color="primary">search</v-icon>
        </v-btn>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="headersPedidos"
          :pagination.sync="pagination"
          :total-items="totalItems"
          :items="pedidos"
          :loading="loading"
          hide-actions
        >
          <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
          <template slot="items" slot-scope="props">
            <tr>
              <td class="text-xs-left">
                <v-tooltip class="hidden-print-only" top>
                    <template v-slot:activator="{ on }">
                        <span class="hidden-print-only" v-on="on">
                            <v-icon color="success">attach_money</v-icon>
                        </span>
                    </template>
                    <span>Compra de Item</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">
                <template v-if="props.item.posto">
                  {{ props.item.posto.nome_fantasia }}<br>
                  {{ props.item.posto.cnpj }}
                </template>
                <template v-else-if="props.item.empresa_vendedora">
                  {{props.item.empresa_vendedora ? props.item.empresa_vendedora.nome_fantasia : ''}}<br>
                  {{props.item.empresa_vendedora ? props.item.empresa_vendedora.cnpj : ''}}
                </template>
              </td>
              <td class="text-xs-left">
                {{ props.item.data.split('T')[0].split('-').reverse().join('/') }}
              </td>
              <td class="text-xs-left">
                <template v-if="props.item.empresa">
                  {{props.item.empresa ? props.item.empresa.nome_fantasia : ''}}<br>
                  {{props.item.empresa ? props.item.empresa.cnpj : ''}}
                </template>
                <template v-else-if="props.item.cliente">
                  {{ props.item.cliente.nome_completo }}<br>
                  {{ props.item.cliente.cpf | cpf }}<br>
                  {{ props.item.cliente ? props.item.cliente.id_pessoa: '' }}
                </template>
                <template v-else>
                  Não encontrado
                </template>
              </td>
              <td class="text-xs-left">
                {{ props.item.total | currency({ fractionCount: 2 }) }}
              </td>
              <td class="text-xs-left">
                <template v-if="props.item.tipo_pagamento">
                  {{ props.item.tipo_pagamento }}
                </template>
                <template v-else>
                  Não Informado
                </template>
              </td>
              <td class="text-xs-left">
                {{ {
                  'pendente': 'Pendente',
                  'em_transito': 'Em Trânsito',
                  'entregue': 'Entregue',
                  'atrasado': 'Atrasado',
                  'cancelado': 'Cancelado',
                  'devolvido': 'Devolvido',
                  'extraviado': 'Extraviado',
                }[props.item.status_entrega] }}
              </td>
              <td class="text-xs-left">
                <v-tooltip v-if="!props.item.finalizado" top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="red">close</v-icon>
                    </template>
                    <span>Não Finalizado</span>
                </v-tooltip>
                <v-tooltip v-else top>
                    <template v-slot:activator="{ on }">
                        <v-icon v-on="on" color="teal">done_all</v-icon>
                    </template>
                    <span>Finalizado</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination color="info" circle v-model="pagination.page" :length="pages"></v-pagination>
        </div>
      </v-flex>
      <v-dialog v-model="dialog" v-if="dialog" width="400">
        <dialog-limite-compra  @fechar="dialog = false"/>
      </v-dialog>
    </v-layout>
    </template>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense v-show="pedidos.length">
          <v-spacer></v-spacer>
          <v-toolbar-title>
            Total: {{ total_relatorio_pedidos | currency({ fractionCount: 2 }) }}
          </v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
    <v-dialog v-if="dialogDetalhes" v-model="dialogDetalhes" width="900">
      <detalhes-compra :compra="compra_selecionada" @carregarPedidos="carregarPedidos" @fechar="dialogDetalhes = false"/>
    </v-dialog>
  </v-container>
</template>

<script>
import SmartLockMessage from '@/components/SmartLockMessage'
import DialogLimiteCompra from '@/components/dialogs/DialogLimiteCompra'
import DetalhesCompra from '@/components/dialogs/DetalhesCompra'

export default {
  components: { SmartLockMessage, DialogLimiteCompra, DetalhesCompra },
  data () {
    return {
      dialogDetalhes: false,
      compra_selecionada: null,
      filtro_comprador: 'todos',
      filtro_vendedor: 'todos',
      item_selecionado: undefined,
      dados_vendedor: [],
      total_relatorio_pedidos: 0,
      dado_selecionado: undefined,
      items_comprador: [],
      filtro_pesquisa: undefined,
      confirmada: true,
      finalizado: true,
      menuData: false,
      confirmadas: true,
      totalItems: null,
      valor: 0,
      menorValor: 0,
      pesquisa_comprador: '',
      pesquisa_vendedor: '',
      pagamento_local: null,
      pagination: {
        rowsPerPage: 5
      },
      data: {
        cpf: null,
        cnpj: null,
        nsu: null,
        codigo: null,
        confirmadas: true,
        dia: null,
        mes: null,
        inicio: null,
        fim: null,
        page: 1
      },
      dialog: false,
      intervalo_relatorio: [],
      dates: [],
      date: null,
      month: null,
      data_relatorio: null,
      mes_relatorio: null,
      cpf: null,
      cnpj: null,
      nsu: null,
      filtro: { text: 'Todas', value: 'todas' },
      filtro_data: 'dia',
      combustivel_selecionado: null,
      pedidos: [],
      items: [
        {
          title: 'Por cliente',
          value: 'cpf'
        },
        {
          title: 'Por posto',
          value: 'cnpj'
        },
        {
          title: 'Por NSU',
          value: 'nsu'
        },
        {
          title: 'Por Código',
          value: 'codigo'
        }
      ],
      itemsData: [
        {
          title: 'Dia',
          value: 'dia'
        },
        {
          title: 'Mês',
          value: 'mes'
        },
        {
          title: 'Intervalo',
          value: 'intervalo'
        }
      ],
      headersPedidos: [
        {
          text: 'Item',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Vendedor',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Data',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Comprador',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Valor',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Pagamento',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Status',
          sortable: false,
          align: 'left'
        },
        {
          text: 'Finalizado',
          sortable: false,
          align: 'left'
        }
      ]
    }
  },
  computed: {
    pages () {
      if (this.pagination.rowsPerPage == null ||
        this.totalItems == null
      ) return 0

      return Math.ceil(this.totalItems / this.pagination.rowsPerPage)
    },
    combustiveis () {
    return this.$store.getters.combustiveis || []
    },
    smartLock () {
      return this.$store.getters.smartLock
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    pagination: {
      handler () {
        this.carregarPedidos(this.pagination)
      },
      deep: true
    },
    filtro_comprador (val) {
      this.item_selecionado = undefined
      switch (val) {
        case 'empresa':
          this.items_comprador = [
            { text: 'CNPJ', value: 'empresa__cnpj' },
            { text: 'Nome fantasia', value: 'empresa__nome_fantasia__icontains' }
          ]
          break
        case 'cliente':
          this.items_comprador = [
              { text: 'CPF', value: 'cliente__pessoa__cpf' },
              { text: 'Número de Identificação', value: 'cliente__pessoa__id_pessoa' },
              { text: 'E-mail', value: 'cliente__pessoa__email' },
              { text: 'Telefone', value: 'cliente__pessoa__telefone' }

          ]
          break
        default:
          this.items_comprador = []
      }
    },
    filtro_vendedor (val) {
      this.dado_selecionado = undefined
      switch (val) {
        case 'posto':
          this.dados_vendedor = [
            { text: 'CNPJ', value: 'posto__cnpj__contains' },
            { text: 'Nome fantasia', value: 'posto__nome_fantasia__icontains' }
          ]
          break
        case 'rede':
          this.dados_vendedor = [
            { text: 'CNPJ do Matriz', value: 'rede__matriz__cnpj' },
            { text: 'Nome', value: 'rede__nome__icontains' }
          ]
          break
        case 'empresa':
          this.dados_vendedor = [
            { text: 'CNPJ', value: 'empresa_vendedora__cnpj' },
            { text: 'Nome fantasia', value: 'empresa_vendedora__nome_fantasia__icontains' }
          ]
          break
        default:
          this.dados_vendedor = []
      }
    },
    date (val) {
      if (val) {
        this.data_relatorio = this.formatDate(this.date)
      }
    },
    month (val) {
      if (val) {
        this.mes_relatorio = this.formatDate(this.month)
      }
    },
    filtro_data (val) {
      if (val) {
        this.data.dia = null
        this.data.mes = null
        this.data.inicio = null
        this.data.fim = null
      }
    }
  },
  filters: {
    cpf: function (value) {
      if (!value) return ''
      value = value.toString()
      value = value.slice(0, 3) + '.' + value.slice(3, 6) + '.' + value.slice(6, 9) + '-' + value.slice(9, 11)
      return value
    }
  },
  methods: {
    formatDate (date) {
      if (!date) return null

      if (this.filtro_data === 'dia' || this.filtro_data === 'intervalo') {
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      } else {
        const [year, month] = date.split('-')
        return `${month}/${year}`
      }
    },
    orderDates () {
      this.dates.sort((a, b) => {
        a = new Date(a.split('-'))
        b = new Date(b.split('-'))
        return a < b ? -1 : a > b ? 1 : 0
      })
    },
    parseDate (date) {
      if (!date) return null

      if (this.filtro_data === 'dia' || this.filtro_data === 'intervalo') {
        const [day, month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      } else {
        const [month, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}`
      }
    },
    dataSelecionada () {
      if (this.filtro_data === 'intervalo') {
        if (this.dates.length === 3) {
          let day1 = this.dates[0]
          let day2 = this.dates[2]
          this.dates = []
          this.dates = [day1, day2]
        }
        if (this.dates.length) {
          this.orderDates()
        }
        this.intervalo_relatorio = this.dates.map(this.formatDate)
      } else {
        this.menuDataInicial = false
      }
    },
    carregarPedidos (pagination) {
      let data = {
        relatorio: true
      }
      data.page = pagination ? pagination.page : 1
      if (this.filtro_comprador !== 'todos') {
        data.empresa_id__isnull = this.filtro_comprador !== 'empresa'
        if (this.pesquisa_comprador) {
          data[`${this.item_selecionado.value}`] = this.pesquisa_comprador
        }
      }
      if (this.filtro_vendedor !== 'todos') {
        if (this.filtro_vendedor === 'empresa') {
          data.empresa_vendedora__isnull = false
        } else if (this.filtro_vendedor === 'posto') {
          data.posto_id__isnull = false
        }
        if (this.dado_selecionado) data[`${this.dado_selecionado.value}`] = this.pesquisa_vendedor
      }
      if (this.filtro && this.filtro.value !== 'todas') {
        data[`${this.filtro.value}`] = this.filtro_pesquisa
      }
      if (this.pagamento_local !== null) {
        data.pagamento_local = this.pagamento_local
      }
      data.finalizado = this.finalizado

      switch (this.filtro_data) {
        case 'dia':
          if (!this.data_relatorio) break
          data.data = `${this.data_relatorio}T00:00:00`
          break
        case 'mes':
          if (!this.mes_relatorio) break
          const dataBusca = this.mes_relatorio.split('/')
          data.data__month = dataBusca[0]
          data.data__year = dataBusca[1]
          break
        case 'intervalo':
          if (!this.intervalo_relatorio) break
          data.data__gte = `${this.intervalo_relatorio[0]}T00:00:00`
          data.data__lte = `${this.intervalo_relatorio[1]}T00:00:00`
          break
      }
      this.$store.dispatch('pegarPedidos', data)
        .then(json => {
          this.pedidos = json.results.pedidos
          this.totalItems = json.count
          this.total_relatorio_pedidos = json.results.total
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
